export function reduceToRecord<E, K extends keyof E>(entities: E[], idKey: K): Record<string, E> {
  return entities.reduce((acc: Record<string, E>, entity: E) => {
    const keyVal = (entity[idKey] as unknown) as string;
    acc[keyVal] = entity;
    return acc;
  }, {});
}
